module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0138.jpg?v=477c727c";